import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import '../App.css';
import Forgot from '../components/Forgot';
import SignIn from '../components/SignIn';
import SignUp from '../components/SignUp';
import Terms from '../components/Terms';
import AuthLanding from '../components/AuthLanding';

import { useAuth } from '../auth/AuthContext';

function Login() {
  const [pageToggle, setPageToggle] = useState('auth-landing');
  const [backToggle, setBackToggle] = useState('');
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const { user, logout } = useAuth();

  // Check for mobile device width
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileDevice(window.innerWidth < 768);
    };
    
    // Initial check
    checkScreenSize();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkScreenSize);
    
    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  // Add custom styling to fix the hover effect on the Talk to Founders button
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      /* Only fix the hover effect without changing the original button color */
      .button.is-small.w-button:hover {
        background-color: inherit !important;
        transform: translateY(-2px) !important;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1) !important;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
      }
      
      /* Mobile warning styles */
      .mobile-warning-container {
        height: 100vh;
        width: 100vw;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: linear-gradient(180deg, #ffffff, #f8fafc);
        padding: 1.5rem;
        text-align: center;
        font-family: "Google Sans", system-ui, -apple-system, sans-serif;
      }
      
      .mobile-warning-card {
        background: white;
        border-radius: 1.5rem;
        border: 1px solid rgba(228, 177, 122, 0.12);
        box-shadow: rgba(228, 177, 122, 0.08) 0px 12px 24px -6px,
                    rgba(228, 177, 122, 0.06) 0px 18px 36px -12px;
        padding: 2rem;
        max-width: 90%;
        position: relative;
        animation: fadeIn 0.5s ease-out forwards;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      }
      
      .mobile-warning-card::before {
        content: "";
        position: absolute;
        inset: 0;
        background: linear-gradient(135deg,
                rgba(253, 248, 243, 0.5) 0%,
                rgba(255, 255, 255, 0.5) 50%,
                rgba(253, 248, 243, 0.5) 100%);
        transition: opacity 0.4s;
        z-index: -1;
        border-radius: inherit;
      }
      
      .mobile-warning-title {
        color: #8c6b4a;
        font-size: 1.5rem;
        font-weight: 600;
        margin-bottom: 1rem;
      }
      
      .mobile-warning-text {
        color: #4b5563;
        font-size: 1rem;
        line-height: 1.5;
        margin-bottom: 1.5rem;
      }
      
      .mobile-warning-logo {
        width: 5rem;
        height: 5rem;
        margin-bottom: 1.5rem;
      }
      
      .mobile-warning-button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.75rem;
        padding: 0.75rem 1.25rem;
        background: linear-gradient(135deg, #e4b17a, #c99b69);
        color: white;
        border-radius: 0.5rem;
        font-weight: 500;
        border: none;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 4px 12px rgba(228, 177, 122, 0.2);
        margin: 0 auto;
        cursor: pointer;
      }
      
      .mobile-warning-button:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(228, 177, 122, 0.3);
        background: linear-gradient(135deg, #d9a46a, #c08b59);
      }
      
      @keyframes fadeIn {
        0% {
          opacity: 0;
          transform: translateY(10px);
        }
        100% {
          opacity: 1;
          transform: translateY(0px);
        }
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    const sessionToken = Cookies.get('session_token');
    const userId = Cookies.get('user_id');

    if (sessionToken && userId) {
      logout();
    }
  }, []);

  const GradeWizHeader = () => {
    return (
      <div className="">
        <div className="flex items-center space-x-2 pb-3">
          <div className="size-12 flex items-center justify-center">
            <img src="/gradewiz_logo.png" alt="GradeWiz Icon" className="size-12" />
          </div>
          <span className="text-minilg font-medium text-gray-950">GradeWiz</span>
        </div>
      </div>
    );
  };
  
  // Mobile warning component
  const MobileWarning = () => {
    return (
      <div className="mobile-warning-container">
        <img src="/gradewiz_logo.png" alt="GradeWiz Icon" className="mobile-warning-logo" />
        
        <div className="mobile-warning-card">
          <h2 className="mobile-warning-title">
            Mobile Access Not Available
          </h2>
          <p className="mobile-warning-text">
            GradeWiz is designed for optimal performance on larger screens. 
            For the best experience with our grading tools and features, 
            please access the platform from a desktop or laptop computer.
          </p>
          <a 
            href="https://calendly.com/maxbohun/gradewiz" 
            className="mobile-warning-button"
            target="_blank"
            rel="noreferrer"
          >
            Contact Us
          </a>
        </div>
        
        <div className="flex items-center justify-center space-x-3 text-gray-500 text-smallish mt-6">
          <button
            onClick={() => {
              setBackToggle(pageToggle);
              setPageToggle('terms');
            }}
            style={{ color: '#8c6b4a' }}
          >
            Terms of Use
          </button>
          <div> |</div>
          <button
            onClick={() => {
              setBackToggle(pageToggle);
              setPageToggle('terms');
            }}
            style={{ color: '#8c6b4a' }}
          >
            Privacy Policy
          </button>
        </div>
      </div>
    );
  };
  
  // If on a mobile device, show the warning
  if (isMobileDevice) {
    return <MobileWarning />;
  }

  return (
    <div className="h-screen">
      <div className="w-full">
        <div className="page-wrapper">
          <div
            data-animation="default"
            className="navbar-component w-nav"
            data-easing2="ease"
            fs-scrolldisable-element="smart-nav"
            data-easing="ease"
            data-collapse="medium"
            data-w-id="2bbb12c9-9300-15f1-6549-3c38dcff06fb"
            role="banner"
            data-duration="400"
          >
            <div className="navbar-container">
              <a
                href="marketing/index.html"
                aria-current="page"
                className="navbar-logo-link w-nav-brand w--current"
              >
                <div className="flex items-center space-x-2 pb-3">
                  <div className="size-12 flex items-center justify-center">
                    <img src="/gradewiz_logo.png" alt="GradeWiz Icon" className="size-12" />
                  </div>
                  <span className="text-minilg font-medium text-gray-950">GradeWiz</span>
                </div>
              </a>

              <div className="navbar-menu-button w-nav-button">
                <div className="menu-icon">
                  <div className="menu-icon-line-top"></div>
                  <div className="menu-icon-line-middle">
                    <div className="menu-icon-line-middle-inner"></div>
                  </div>
                  <div className="menu-icon-line-bottom"></div>
                </div>
              </div>
              <div className="navbar-menu-desktop">
                <div className="w-layout-vflex flex-block-2">
                  <a
                    href="https://calendly.com/maxbohun/gradewiz"
                    className="button is-small w-button"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Talk to Founders
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`bg-backgray h-screen w-screen pt-14 flex flex-col justify-between ${pageToggle === 'create-account' || pageToggle === 'terms' ? 'pt-5' : 'pt-14'}`}
      >
        <div
          className={`flex items-center justify-center w-[300px] mx-auto p-6 sexy-border ${pageToggle === 'create-account' || pageToggle === 'terms' ? 'h-[580px]' : 'h-[485px]'}`}
        >
          <div
            className={`absolute w-[350px] mx-auto p-6 sexy-border bg-white mt-6 flex flex-col justify-between ${pageToggle === 'create-account' || pageToggle === 'terms' ? 'h-[580px]' : 'h-[485px]'}`}
          >
            {pageToggle === 'auth-landing' && (
              <AuthLanding setPageToggle={setPageToggle} GradeWizHeader={GradeWizHeader} />
            )}
            {pageToggle === 'sign-in' && (
              <SignIn setPageToggle={setPageToggle} GradeWizHeader={GradeWizHeader}></SignIn>
            )}
            {pageToggle === 'create-account' && (
              <SignUp
                setPageToggle={setPageToggle}
                pageToggle={pageToggle}
                setBackToggle={setBackToggle}
                GradeWizHeader={GradeWizHeader}
              ></SignUp>
            )}
            {pageToggle === 'forgot-password' && (
              <Forgot
                setPageToggle={setPageToggle}
                setBackToggle={setBackToggle}
                backToggle={backToggle}
                GradeWizHeader={GradeWizHeader}
              ></Forgot>
            )}
            {pageToggle === 'terms' && (
              <Terms
                setPageToggle={setPageToggle}
                backToggle={backToggle}
                GradeWizHeader={GradeWizHeader}
              ></Terms>
            )}
          </div>
        </div>
        <div className="flex items-center justify-center space-x-3 text-gray-500 text-smallish mb-28">
          <button
            onClick={() => {
              setBackToggle(pageToggle);
              setPageToggle('terms');
            }}
          >
            Terms of Use
          </button>
          <div> |</div>
          <button
            onClick={() => {
              setBackToggle(pageToggle);
              setPageToggle('terms');
            }}
          >
            Privacy Policy
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;
